import { Id } from 'src/types'

export enum AgencyPartnersActionTypes {
  GET_AGENCY_PARTNERS = '@agencyPartners/GET_AGENCY_PARTNERS',
  GET_AGENCY_PARTNERS_FAILURE = '@agencyPartners/GET_AGENCY_PARTNERS_FAILURE',
  GET_AGENCY_PARTNERS_SUCCESS = '@agencyPartners/GET_AGENCY_PARTNERS_SUCCESS',
  SEND_AGENCY_PARTNERS = '@agencyPartners/SEND_AGENCY_PARTNERS',
  SEND_AGENCY_PARTNERS_FAILURE = '@agencyPartners/SEND_AGENCY_PARTNERS_FAILURE',
  SEND_AGENCY_PARTNERS_SUCCESS = '@agencyPartners/SEND_AGENCY_PARTNERS_SUCCESS'
}

export type ResponseDataRequests = {
  agency_partners: ResponseDataRequestsItem[]
}

export interface ResponseDataRequestsItem {
  agency_partner_id: Id
  partner_id: Id
  description: string
  active: boolean
}

export type ResponseDataRequestTotals = {
  request_totals: {
    total_emissions: number
    total_quotations: number
  }
}

export type AgencyPartnersState = ResponseDataRequestTotals & {
  readonly error: string
  readonly list: ResponseDataRequestsItem[]
  readonly loading: boolean
  readonly sendAgencyPartnersError: string
  readonly sendAgencyPartnersLoading: boolean
  readonly total_results: number
}
